import script from "./Logos.vue?vue&type=script&setup=true&lang=ts"
export * from "./Logos.vue?vue&type=script&setup=true&lang=ts"

import "./Logos.vue?vue&type=style&index=0&id=647a0822&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-647a0822"]])

export default __exports__